import React, { Component } from "react";
// import { useParams } from 'react-router-dom';
import axios from "axios";
import $ from "jquery";
import HeadersAuth from "../Layouts/HeadersAuth";

export class UpdatePassword extends Component {
  constructor(props) {
    super(props);

   

    this.state = {
      error: null,
      isLoaded: false,
      updatePassword: "",
      password: "",
      password2: "",
      loading: false,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    // //this.PrintWindow = this.PrintWindow.bind(this);
  }
  componentDidMount() {
    console.log(localStorage.getItem("changePassword"));
    if (localStorage.getItem("changePassword")) {
      $(".updatePassword").prop("disabled", false);
      this.setState({ updatePassword: localStorage.getItem("changePassword") });
    }
    document.getElementById("LoadingModal").style.display = "none";
  }
  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }
  handleSubmit(event) {
    const headers = {
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
      recoverparams: this.state.updatePassword,
    };
    let self = this;
    event.preventDefault();
    if (this.state.password == this.state.password2) {
      this.setState({ loading: true });
      axios
        .post(this.api_url+"staff/newpassword", this.state, {
          headers: headers,
        })
        .then((response) => {
          this.setState({ loading: false });
          console.log(response);
          if (response.data["success"] == "password changed, reverify account with admin") {
            $(".alert-success").show();

            setTimeout(function (props) {
              // history.push('/reception/dashboard')
              window.location = "/";
            }, 2000);
            // this.props.history.push('/reception/dashboard')
          }
        })
        .catch((error) => {
          $(".alert-danger").show();

          this.setState({ loading: false });
          console.log(error);
        });
    }
  }

  render() {
    const font16 = { fontSize: "16px" };
    const fontFamilyNunito = { fontFamily: "Nunito, sans-serif" };
    const floatRight = { float: "right;" };
    const floatLeft = { float: "left;" };
    const displayHidden = { display: "none" };
    let forgotPasswordUrl = "/forgot/password";
    const { password, password2 } = this.state;
    const loading = this.state.loading;

    return (
      <div>
        <HeadersAuth />
        <main>
          <div className="container p-2">
            <form onSubmit={this.handleSubmit}>
              <div className="form-row pt-4">
                <div className="col-md-4 text-lg-center font-weight-bold p-1">
                  <p className="text-capitalize" style={font16}></p>
                </div>

                <div className="col-md-4 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      New Password
                    </h6>
                    <input
                      className="form-control"
                      type="password"
                      name="password"
                      onChange={this.handleChange}
                      value={password}
                    />
                  </div>
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Confirm Password
                    </h6>
                    <input
                      className="form-control"
                      type="password"
                      name="password2"
                      onChange={this.handleChange}
                      value={password2}
                    />
                  </div>
                </div>
              </div>

              <center>
                <div
                  id="loginSuccess"
                  className="alert alert-success"
                  style={displayHidden}
                  role="alert"
                >
                  <strong>Success! </strong>Password changed Successfully. Login
                  to access your account
                </div>
                <div
                  className="alert alert-danger"
                  id="loginError"
                  style={displayHidden}
                  role="alert"
                >
                  <strong>Sorry </strong>Something went wrong please try again
                </div>
                <div className="row">
                  <div style={displayHidden} className="col col-6">
                    <button
                      className="btn btn-primary btn-warning rounded-pill px-4 font-weight-bold"
                      type="button"
                      style={floatRight}
                    >
                      Send To Triage
                    </button>
                  </div>
                  <div className="col col-6">
                    <button
                      className="btn btn-primary btn-warning rounded-pill px-5 font-weight-bold updatePasswordbtn"
                      type="submit"
                      style={floatLeft}
                    >
                      {" "}
                      {loading ? <span>Loading...</span> : <span>Submit</span>}
                    </button>
                  </div>
                </div>
              </center>
            </form>
          </div>
        </main>
      </div>
    );
  }
}

export default UpdatePassword;
